import '@/assets/scss/element.scss'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import VueClipboard from 'vue-clipboard2'
import VueKonva from 'vue-konva'
import md5 from 'js-md5' //密码 需要 md5加密
import { MessageBox } from 'element-ui'
import tools from './utils/tools'
import vueFilter from './utils/filter'
import config from './config/index'
import * as funcs from '@/utils/function'
import i18n, {en, zh} from '@/utils/i18n'
import business from '@/utils/business'
import './utils/gobal'
import './permission' //路由权限
import 'swiper/css/swiper.css'

//默认头像
import person from './assets/images/person.png'
import actor from './assets/images/actor.png'
import exhLogo from './assets/images/exhLogo.png'
import product from './assets/images/product.png'
import product3 from './assets/images/product2.png'
import VueLazyload from 'vue-lazyload'
/**
 * 使 axios 支持 finally
 */
import promiseFinally from 'promise.prototype.finally'
promiseFinally.shim()

Vue.use(VueAwesomeSwiper /* { default options with global component } */)


Vue.use(VueLazyload, {
  attempt: 1
})

Vue.use(VueKonva)
Vue.use(VueClipboard)

Vue.config.productionTip = false

Vue.prototype.$md5 = md5
Vue.prototype.$funcs = funcs

// 全局配置项
Vue.prototype.$config = config

Object.keys(tools).forEach(key => {
  Vue.prototype[key] = tools[key]
})

Object.keys(vueFilter).forEach(key => {
  Vue.filter(key, vueFilter[key])
})

Object.keys(business).forEach(key => {
  Vue.prototype[key] = business[key]
})

// 默认头像
Vue.prototype.defImage = function(type) {
  if (type == 'head') {
    return person
  } else if (type == 'actor') {
    return actor
  } else if (type == 'product') {
    return exhLogo
  } else if (type == 'product1') {
    return product3
  } else if (type == 'product2') {
    return product3
  } else if (type == 'product3') {
    return product3
  } else {
    return product
  }
}

Vue.prototype.minImageThree = function(list = [], type) {
  if(list.length < 1) {
    for(let i = list.length; i<1; i++) {
      if (type == 'product2'){
        list.push(product3)
      } else if (type == 'product3') {
        list.push(product3)
      } else {
        list.push(product)
      }
    }
  }
  return list
}

// window.PC = window.PC || {}
window.PC.setLang(zh, en)
window.PC.$config = config

if (funcs.browser.trident) {
  MessageBox.confirm('暂不支持IE,请使用其他浏览器', '提示', {
    showClose: false,
    showCancelButton: false,
    showConfirmButton: false,
    closeOnClickModal: false,
    type: 'warning'
  })
} else {
  window.vm = new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
  }).$mount('#app')

  window.PC.app = window.vm
}
